import Vue from 'vue'
import { savePreviousData } from '@/services/api'
import { calculateQantityPer } from '@/services/calculate'
import { formatValue } from '@/services/convert'
import { Input } from 'ant-design-vue'

Vue.use(Input)

export default Vue.extend({
  template: `
    <div class="a-gcell">
      <a-input
        type="number"
        size="small"
        v-model="value"
        ref="txt-input"
        :autoFocus="true"
        :min="params.colDef.cellRendererParams.min"
        :max="params.colDef.cellRendererParams.max"
        :placeholder="params.colDef.cellRendererParams.placeholder"
        title=""
        @focus="savePreviousData(value)"
        @blur="saveData($event)"
        @keydown.tab="saveData($event)"
        @keydown.enter="saveData($event)"
      />
    </div>
    `,

  data() {
    return {
      value: null,
      loading: false,
      savePreviousData: savePreviousData,
      keyCode: undefined,
    }
  },

  created() {
    this.keyCode = undefined
    if (
      this.params.data &&
      (this.params.colDef.field === 'quantity_Percentage' ||
        this.params.colDef.field === 'quantityPercentage') &&
      this.params.data.unit === 'SF'
    ) {
      const quantity = this.params.data.quantity
        ? this.params.data.quantity
        : 0
      this.value = calculateQantityPer(quantity, this.params.data.area)
    }
    if (
      (this.params.value || this.params.value === 0) &&
      this.params.colDef.field !== 'quantity_Percentage' &&
      this.params.colDef.field !== 'quantityPercentage'
    ) {
      this.value = formatValue(
        this.params.value,
        this.params.colDef.cellRendererParams.precision,
      )
    }
  },

  methods: {
    saveData(event) {
      if (!this.keyCode) {
        this.keyCode = event.keyCode
        if (
          (this.params.colDef.cellRendererParams.precision === 0 ||
            this.params.colDef.cellRendererParams.precision > 0) &&
          event.target.value
        ) {
          this.value = formatValue(
            event.target.value,
            this.params.colDef.cellRendererParams.precision,
          )
        }
        switch (this.params.colDef.cellRendererParams.type) {
          case 'dynamicTable':
            this.$root.$emit(
              'handleChange',
              this.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              this.keyCode,
            )
            break
          case 'analysisSheet':
          case 'AnalysisSheet':
            this.$root.$emit(
              'saveAnalysisData',
              this.value,
              this.params.data,
              this.params.colDef.field,
              this.params.data.columnId,
            )
            break
          case 'tenants':
            this.$root.$emit(
              'saveTenantData',
              this.params.colDef.field,
              this.value,
              this.params.colDef.headerName,
              this.params.data,
            )
            break
          case 'projectTenants':
            this.$root.$emit(
              `saveTenantData${this.params.data.assetId}`,
              this.params.colDef.field,
              this.value,
              this.params.colDef.headerName,
              this.params.data,
            )
            break
          case 'projectDetails':
            this.$root.$emit(
              'updateAssetsDetails',
              this.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
            )
            break
          case 'actualCostLevel':
            this.$root.$emit(
              'handleTileChange',
              this.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
            )
            break
          case 'interiorGrouping':
            this.$root.$emit(
              'updateGrouping',
              this.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              this.keyCode,
            )
            break
          case 'estimateGroup':
            this.$root.$emit(
              `onUpdateTakeoff${this.params.data.assetId}`,
              this.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              this.keyCode,
            )
            break
          case 'estimateTakeoff':
            this.$root.$emit(
              'onUpdateTakeoffs',
              this.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              this.keyCode,
            )
            break
          default:
            break
        }
      }
    },

    getValue() {
      if (
        this.value &&
        (this.params.colDef.cellRendererParams.precision === 0 ||
          this.params.colDef.cellRendererParams.precision > 0)
      ) {
        return formatValue(
          this.value,
          this.params.colDef.cellRendererParams.precision,
        )
      } else {
        return this.value
      }
    },

    isNumber(evt) {
      evt = !evt ? window.event : evt
      var charCode = evt.which ? evt.which : evt.keyCode
      if (this.params.colDef.cellRendererParams.precision === 0) {
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          evt.preventDefault()
        } else if (this.value && this.params.colDef.cellRendererParams.max) {
          const value = Number(this.value + evt.key)
          if (value > this.params.colDef.cellRendererParams.max) {
            evt.preventDefault()
          } else {
            return true
          }
        }
      } else if (this.value && this.params.colDef.cellRendererParams.max) {
        const value = Number(this.value + evt.key)
        if (value > this.params.colDef.cellRendererParams.max) {
          evt.preventDefault()
        } else {
          return true
        }
      }
      return true
    },
  },
})
